module.exports = __webpack_public_path__ + "media/images/icon-instagram-2c42927377d27224e1beca9622e4cdf1.svg";